import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  tableContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  checkboxCell: {
    width: 48,
    padding: theme.spacing(0, 1),
  },
  actionsCell: {
    width: 48,
    padding: theme.spacing(0, 1),
  },
  statusChip: {
    height: 22,
    fontSize: 11,
  },
  dropzone: {
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  dropzoneActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
  },
  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0),
  },
  alertBox: {
    marginBottom: theme.spacing(2),
  },
  dialogActions: {
    padding: theme.spacing(2),
  },
}))

export default useStyles
